import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import "./style.scss";
import Sidebar from "../../../components/sidebar";
import { useNavigate, useOutletContext } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { DeleteModalType } from "../../../constants/utlis";
import DeleteModal from "../../../components/deleteModal";
import { useDispatch, useSelector } from "react-redux";
import { getInviteUserList } from "../../../core/data/redux/manageUser/_manageUserAction";
import ResendInviteModal from "../../../components/resendInviteModal";
import ResendInviteIcon from "../../../icons/ResendInviteIcon";
import PlusIcon from "../../../icons/PlusIcon";
import DeleteRedOutlineIcon from "../../../icons/DeleteRedOutlineIcon";
import {
  capitalizeFullName,
  capitalizeFullRole,
  getPlanNameFromAppleId,
} from "../../../constants/common";
import { getStorageItem } from "../../../services/storage.service";

interface OutletContext {
  isSidebarOpen: boolean;
  onToggleSidebar: () => void;
}

const ManageUser: React.FC = () => {
  const { isSidebarOpen, onToggleSidebar } = useOutletContext<OutletContext>();
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const route = all_routes;

  const userList = useSelector((state: any) => state?.manageUser?.userList);

  const [modalType, setModalType] = useState<DeleteModalType>("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedUserUuid, setSelectedUserUuid] = useState<string | null>(null);
  const [showResendInviteModal, setShowResendInviteModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState<any>(null);

  const userDetail: any = getStorageItem("userData") || null;
  const userData = userDetail !== null ? JSON.parse(userDetail) : null;
  const planPermission = userData?.plan_permissions;
  const manageUserPermission = (planPermission?.plan_name.toLowerCase() !== "basic") && planPermission?.permissions?.invite_spouse && planPermission?.permissions?.invite_tax_professionals;
  const planData = useSelector(
    (state: any) => state?.user?.userDetail?.user_subscription
  );
  const planNameFromApple: any = getPlanNameFromAppleId(planData?.apple_plan_id);
  const normalizedApplePlan = (planNameFromApple || "").toUpperCase();
  const normalizedWebPlan = (planPermission?.plan_name || "").toUpperCase();

  const isAllowed = planData
    ? ["PRO", "INVESTOR"].includes(normalizedApplePlan)
    : ["PRO", "INVESTOR"].includes(normalizedWebPlan);
console.log('isAllowed==>',isAllowed);

  const isSpouseAccepted = userList?.some(
    (user: any) => user?.role?.toLowerCase() === "spouse"
    //  && user?.status?.toLowerCase() === "accept"
  );
  const isTaxProAccepted = userList?.some(
    (user: any) =>
      user?.role?.toLowerCase() === "tax professional" && !user?.archieve
    //  && user?.status?.toLowerCase() === "accept"
  );
  const anyUserExpired = userList?.some(
    (user: any) => user?.status?.toLowerCase() === "expire"
  );

  // Check if a spouse exists
  const hasSpouse = userList?.some(
    (user: any) => user?.role?.toLowerCase() === "spouse"
  );
  // Check if all tax professionals are archived
  const allTaxProsArchived = userList
    ?.filter(
      (user: any) =>
        user?.role?.toLowerCase() === "tax professional" ||
        user?.role?.toLowerCase() === "tax_professional"
    )
    ?.every((user: any) => user?.archieve === true);
  // Check if any tax professional exists
  const hasTaxPro = userList?.some(
    (user: any) =>
      user?.role?.toLowerCase() === "tax professional" ||
      user?.role?.toLowerCase() === "tax_professional"
  );

  console.log(
    "hasSpouse: ",
    hasSpouse,
    "   allTaxProsArchived: ",
    allTaxProsArchived,
    "   hasTaxPro: ",
    hasTaxPro
  );

  // Show invite button only if:
  // 1. List is empty OR
  // 2. No spouse OR
  // 3. No tax professional OR
  // 4. All tax professionals are archived
  const showInviteButton =
    userList?.length === 0 || !hasSpouse || !hasTaxPro || allTaxProsArchived;

  // Fetch users on component mount
  useEffect(() => {
    dispatch(getInviteUserList({}));
  }, [dispatch]);

  const handleAddUser = () => {
    navigate(route.addMember);
  };

  const handleOpenDeleteModal = (type: DeleteModalType, uuid: string) => {
    setModalType(type);
    setSelectedUserUuid(uuid);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedUserUuid(null);
  };

  const handleResendUserInviteModal = (user: any) => {
    console.log("user ++++++++++ ", user);
    setSelectedUser(user);
    setShowResendInviteModal(true);
  };

  const handleCloseResendUserInviteModal = () => {
    setShowResendInviteModal(false);
    setSelectedUser(null);
    console.log("selectedUser ++++++++++ ", selectedUser);
  };

  const handleToggleStatus = (user: any, newStatus: boolean) => {
    if (newStatus) {
      handleOpenDeleteModal("activeUser", user?.uuid);
    } else {
      handleOpenDeleteModal("inactiveUser", user?.uuid);
    }
  };

  return (
    <>
      <div className="layout">
        {/* Sidebar */}
        <Sidebar isOpen={isSidebarOpen} />

        {/* Main Content */}
        <main className="content">
          <div className="profileSettings manager-user">
            <div className="manager-user-section d-flex justify-content-between align-items-center mb-4">
              <h2 className="mb-0">Manage User’s</h2>

              {showInviteButton && (
                <button
                  className="btn primaryButton text-white"
                  onClick={handleAddUser}
                  disabled={!isAllowed}
                >
                  <PlusIcon /> Invite User
                </button>
              )}
            </div>

            <div className="table-section">
              <div className={`table-responsive_1 ${!isAllowed ? "disabled" : ""}`}>
                <Table bordered hover responsive>
                  <thead>
                    <tr>
                      <th>User Image</th>
                      <th>Invitation</th>
                      <th>Invitee</th>
                      <th>Total Hours</th>
                      <th>User Type</th>
                      <th>Invite</th>
                      <th>Active / Inactive</th>
                      {/* <th>Actions</th> */}
                      {anyUserExpired && <th>Actions</th>}
                    </tr>
                  </thead>

                  <tbody>
                    {userList?.length > 0 ? (
                      userList?.map((user: any, index: number) => (
                        <tr key={index}>
                          <td>
                            <img
                              src={user?.image || "/assets/img/userCircle.png"}
                              alt="User"
                              className="rounded-circle"
                              width="40"
                              height="40"
                            />
                          </td>
                          <td>{capitalizeFullName(user?.name) || "N/A"}</td>
                          <td>{user?.email || "N/A"}</td>
                          {/* <td>{user?.total_hours || "0 hours"}</td> */}
                          <td>{user?.role?.toLowerCase() === "spouse" ? user?.total_hours || "0 hours" : "--"}</td>
                          <td>
                            <p
                              className={
                                user?.role?.toLowerCase() === "spouse"
                                  ? "Spouse"
                                  : "tax"
                              }
                            >
                              {capitalizeFullRole(user?.role) || "N/A"}
                            </p>
                          </td>
                          <td>
                            <div className="d-flex justify-content-center">
                              <p
                                className={`status-text mb-0 ${user?.status?.toLowerCase() === "accept"
                                  ? "accept"
                                  : user?.status?.toLowerCase() === "expire"
                                    ? "expire"
                                    : "pending"
                                  }`}
                              >
                                {user?.status?.toLowerCase() === "accept"
                                  ? "Accepted"
                                  : user?.status?.toLowerCase() === "expire"
                                    ? "Expired"
                                    : "Pending"}
                              </p>
                            </div>
                          </td>
                          <td>
                            <Form.Check
                              type="switch"
                              id="custom-switch"
                              checked={
                                !user?.archieve &&
                                user?.status?.toLowerCase() === "accept"
                              }
                              onChange={(e) =>
                                handleToggleStatus(user, e.target.checked)
                              }
                              disabled={
                                user?.status?.toLowerCase() === "pending" ||
                                user?.status?.toLowerCase() === "expire"
                              }
                            />
                          </td>

                          {anyUserExpired && (
                            <td>
                              <div className="svg-icon">
                                {user?.status?.toLowerCase() === "expire" && (
                                  <>
                                    <button
                                      className="svg-icon-sendBtn"
                                      onClick={() =>
                                        handleResendUserInviteModal(user)
                                      }
                                    >
                                      <ResendInviteIcon />
                                    </button>

                                    <button
                                      className="svg-icon-bi-trash"
                                      onClick={() =>
                                        handleOpenDeleteModal(
                                          "deleteInvitedUser",
                                          user?.uuid
                                        )
                                      }
                                    >
                                      <DeleteRedOutlineIcon />
                                    </button>
                                  </>
                                )}

                                {/* {(user?.status?.toLowerCase() === "accept") && (
                                <button
                                  className="svg-icon-bi-trash"
                                  onClick={() => handleOpenDeleteModal("archiveUser", user?.uuid)}
                                >
                                  <ArchiveIcon />
                                </button>
                              )} */}
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="text-center">
                          No users found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>

            {(!isAllowed) && (
              <p className="text-danger mt-5 fw-semibold text-center">
                {/* Your current plan does not include CPA or spouse access. Connected users have been disabled. */}
                Adding CPA and Spouse is not available with the Basic Plan. Upgrade to unlock these features.
              </p>
            )}
          </div>
        </main>
      </div>

      <DeleteModal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        type={modalType}
        uuid={selectedUserUuid}
      />

      <ResendInviteModal
        show={showResendInviteModal}
        onHide={handleCloseResendUserInviteModal}
        data={selectedUser}
      />
    </>
  );
};

export default ManageUser;
